export default {
  data() {
    return {
      applying: false,
      filterDisplay: {
        hideCompany: true,
        hideRegion: true,
        hideBranch: true,
        hideDevice: true,
        hidePromotionalInfo: null,
        hideDate: true
      },
      filters: {
        company: null,
        region: null,
        branch: null,
        device: null,
        promotionalInfo: null,
        fromDate: "",
        toDate: "",
        exportData: false
      }
    };
  },
  computed: {
    isUser() {
      return this.$store.getters.isUser;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    hideCompany() {
      if (this.isSuperAdmin) {
        return false;
      }
      return true;
    },
    hideAllFilters() {
      return (
        this.filterDisplay.hideCompany &&
        this.filterDisplay.hideRegion &&
        this.filterDisplay.hideBranch &&
        this.filterDisplay.hideDevice &&
        this.filterDisplay.hidePromotionalInfo &&
        this.filterDisplay.hideDate
      );
    },
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    setupFilter() {
      this.filters.company = this.currentUser.company;
      if (this.isSuperAdmin) {
        this.filterDisplay.hideCompany = false;
      }
    }
  }
};
